import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import HolidaysForm from '../components/forms/HolidaysForm';
import '../styles/EmployeeMaster.css';
import HolidayTable from '../components/HolidayTable';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const HolidayModel = () => {
     const navigate = useNavigate();
     const location = useLocation();
     const [showModal, setShowModal] = React.useState(false);
     const [editHoliday, setEditHoliday] = React.useState(null);
     const [loading, setLoading] = React.useState(false);

     // Expose setEditHoliday globally for HolidayTable to call
     React.useEffect(() => {
          window.setEditHoliday = (item) => {
               setEditHoliday(item);
               setShowModal(true);
          };
          return () => { delete window.setEditHoliday; };
     }, []);

     // Open modal for add/edit based on route
     React.useEffect(() => {
          const matchAdd = location.pathname === '/holiday/add';
          const matchEdit = /^\/holiday\/edit\/(\d+)$/.test(location.pathname);
          setShowModal(matchAdd || matchEdit);
          if (matchEdit) {
               // Fetch holiday data if not already set
               if (!editHoliday || `/holiday/edit/${editHoliday.id}` !== location.pathname) {
                    const id = location.pathname.split('/').pop();
                    setLoading(true);
                    fetch(`${process.env.REACT_APP_BASE_URL}/getHolidayById/${id}`)
                         .then(res => res.json())
                         .then(data => {
                              if (data.status && data.data) setEditHoliday(data.data);
                              else setEditHoliday(null);
                         })
                         .catch(() => setEditHoliday(null))
                         .finally(() => setLoading(false));
               }
          } else if (matchAdd) {
               setEditHoliday(null);
          }
     }, [location.pathname]);

     const handleAddClick = () => {
          navigate('/holiday/add');
     };

     const handleCloseModal = () => {
          setShowModal(false);
          setEditHoliday(null);
          navigate('/Holiday');
     };

     return (
          <>
               <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
               <div className="employee-master-page">
                    <div className="employee-header">
                         <h2>Holiday Master</h2>
                         <button className="add-employee-btn" onClick={handleAddClick}>
                              Add Holiday
                         </button>
                    </div>

                    <HolidayTable />

                    <Modal
                         show={showModal}
                         onHide={handleCloseModal}
                         size="md"
                         centered
                    >
                         <Modal.Header closeButton>
                              <Modal.Title>{editHoliday ? 'Edit Holiday' : 'Add New Holiday'}</Modal.Title>
                         </Modal.Header>
                         <Modal.Body>

                              <HolidaysForm HolidayId={editHoliday?.id} initialData={editHoliday} onSuccess={handleCloseModal} />

                         </Modal.Body>
                    </Modal>
               </div>
          </>
     );
};

export default HolidayModel;
